import * as React from 'react'
import { BButton, BCol, BRow, BText, BModal, BTitle, BIcon } from '@prague-digi/ui-components'

import messages from '../../i18n'
import { intl, IntlInterface } from '../../hoc'

interface Props extends IntlInterface {
  cancel: Function
  goBack: Function
}

export const LeaveConfirmation = (props: Props) => (
  <BModal isOpen zIndex={1030}>
    <BRow>
      <BCol lg={11}>
        <BTitle type="h4">{props.translate(messages.LeaveConfirmation.title)} </BTitle>
      </BCol>
      <BCol lg={1}>
        <BButton onClick={props.cancel} theme="close float-right">
          <BIcon name="close" theme="float-right mr-0" />
        </BButton>
      </BCol>
    </BRow>

    <BText message={props.translate(messages.LeaveConfirmation.description)} />
    <BRow theme="mt-4">
      <BCol>
        <BButton
          data-test-id="leaveConfirmationExit"
          messages={{ message: props.translate(messages.LeaveConfirmation.leave) }}
          onClick={props.goBack}
          theme="w-100"
        />
      </BCol>
      <BCol>
        <BButton
          color="primary"
          data-test-id="leaveConfirmationStay"
          messages={{ message: props.translate(messages.LeaveConfirmation.stay) }}
          onClick={props.cancel}
          theme="w-100"
        />
      </BCol>
    </BRow>
  </BModal>
)

export default intl(LeaveConfirmation)
